export function initializeStickyBox() {
    if (window.innerWidth <= 768) return;

    const stickyBox = document.querySelector('.sticky-box');
    if (!stickyBox) return;

    ScrollTrigger.create({
        trigger: stickyBox,
        start: 'top top+=200',
        end: 'bottom top-=50',
        pin: true,
        pinSpacing: true,
    });
}
